import { useMemo, type ReactNode } from "react";
import { usePolicy, policyAt, PolicyContext } from "@/lib/policy/policy-shared";

/** The same policy worked out for the building being looked at, the menu and every button: a strong
 * role at one building does not open its screens at another, and a building's administrator sees
 * her own building's. */
export function PolicyScope({
  facilityId,
  children,
}: {
  facilityId: string | null;
  children: ReactNode;
}) {
  const parent = usePolicy();
  const value = useMemo(
    () => policyAt(parent.me, parent.subject, facilityId),
    [parent.me, parent.subject, facilityId],
  );
  return <PolicyContext.Provider value={value}>{children}</PolicyContext.Provider>;
}
